import { Box } from "@mui/material";

function EmptyContentPlaceholder() {
  return <Box sx={{ marginTop: "200px", paddingBottom: "100px" }} />;
}

export default EmptyContentPlaceholder;
